var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"sa-content"},[_c('notific-msg')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }